import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Meal, MealTime } from 'src/app/models/base.model';
import { APP_STATE_TOKEN } from '../../../../store/app/app.state.model';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import {
  GetRealtimeSalesByPosOperators,
  PosManagerSelectors
} from '../../../../store/pos-manager';
import { SalesByPosOperatorsResponse } from '../../../../models';
import { MealHelper } from '../../../../helpers';
import { ReactiveComponent } from '../../../../components/shared/reactive-component';
import { Router } from '@angular/router';

@Component({
  selector: 'pos-operators',
  templateUrl: './pos-operators.page.html',
  styleUrls: ['./pos-operators.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PosOperatorsPage extends ReactiveComponent {
  @Input() selectedMealId: MealTime;
  @Input() selectedDateStr: string;
  @Input() selectedLocationId: number;

  @ViewSelectSnapshot(PosManagerSelectors.getRealtimeSalesByPosOperators)
  salesByPosOperators: SalesByPosOperatorsResponse | undefined;

  readonly MEALS: Meal[] = MealHelper.MEALS;
  form: FormGroup;
  sortColumn: 'name' | 'orders' = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private readonly store: Store,
    private readonly cdr: ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private readonly router: Router
  ) {
    super();
    const navigationState = this.router.getCurrentNavigation()?.extras?.state;
    if (navigationState) {
      this.selectedMealId =
        navigationState.selectedMealId || this.selectedMealId;
      this.selectedDateStr =
        navigationState.selectedDateStr || this.selectedDateStr;
      this.selectedLocationId =
        navigationState.selectedLocationId ||
        this.store.selectSnapshot(APP_STATE_TOKEN).device?.pos_location_id;
    }

    this.form = this.fb.group({
      selectedMealId: [this.selectedMealId],
      selectedLocationId: [
        this.selectedLocationId ||
          this.store.selectSnapshot(APP_STATE_TOKEN).device?.pos_location_id
      ]
    });
  }

  readonly MealTime = MealTime;

  *onSubscribe() {
    this.fetchPosOperatorData();

    yield this.form
      .get('selectedMealId')
      ?.valueChanges.subscribe((mealId: MealTime) => {
        this.fetchPosOperatorData(mealId);
      });
  }

  private fetchPosOperatorData(mealId?: MealTime) {
    const currentMealId = mealId || this.form.get('selectedMealId')?.value;

    if (currentMealId && this.selectedDateStr && this.selectedLocationId) {
      return this.store.dispatch(
        new GetRealtimeSalesByPosOperators({
          date: this.selectedDateStr,
          pos_location: this.selectedLocationId,
          meal_id: currentMealId
        })
      );
    }
    return null;
  }

  toggleSort(column: 'name' | 'orders') {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
  }
}
